<section class="registration-shell" [class.registration-shell--plan]="stepper.selectedIndex === 2">
  <div class="registration-shell__grid">
    <aside class="registration-hero" *ngIf="stepper.selectedIndex !== 2">

      <!-- Statischer Hero: Schritt 1 (Firma) und Schritt 4 (Laden) -->
      <ng-container *ngIf="stepper.selectedIndex !== 1">
        <img src="assets/branding/Docuty_Logo_White_Gruener_Haken.png" alt="Docuty" class="registration-hero__logo" />
        <h1 class="registration-hero__title">
          <span>{{ "REGISTER.HERO_TITLE_LINE1" | translate }}</span><br>
          <span>{{ "REGISTER.HERO_TITLE_LINE2" | translate }}</span><br>
          <span>{{ "REGISTER.HERO_TITLE_LINE3" | translate }}</span>
        </h1>
        <p class="registration-hero__description">{{ "REGISTER.HERO_DESCRIPTION" | translate }}</p>

        <div class="registration-hero__highlights">
          <div class="registration-hero__highlight">
            <span class="registration-hero__highlight-icon">01</span>
            <div>
              <h2>{{ "REGISTER.HIGHLIGHT_ONE_TITLE" | translate }}</h2>
              <p>{{ "REGISTER.HIGHLIGHT_ONE_TEXT" | translate }}</p>
            </div>
          </div>
          <div class="registration-hero__highlight">
            <span class="registration-hero__highlight-icon">02</span>
            <div>
              <h2>{{ "REGISTER.HIGHLIGHT_TWO_TITLE" | translate }}</h2>
              <p>{{ "REGISTER.HIGHLIGHT_TWO_TEXT" | translate }}</p>
            </div>
          </div>
          <div class="registration-hero__highlight">
            <span class="registration-hero__highlight-icon">03</span>
            <div>
              <h2>{{ "REGISTER.HIGHLIGHT_THREE_TITLE" | translate }}</h2>
              <p>{{ "REGISTER.HIGHLIGHT_THREE_TEXT" | translate }}</p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Dynamischer Context: Schritt 2 (Einsatzbereich) -->
      <ng-container *ngIf="stepper.selectedIndex === 1">
        <img src="assets/branding/Docuty_Logo_White_Gruener_Haken.png" alt="Docuty" class="registration-hero__logo" />
        <p class="registration-hero__eyebrow">{{ selectedIndustryLabel }}</p>
        <h1 class="registration-hero__title registration-hero__title--context">
          {{ currentIndustryContext.title }}
        </h1>

        <div class="registration-hero__highlights">
          <div class="registration-hero__highlight" *ngFor="let step of currentIndustryContext.steps; let i = index">
            <span class="registration-hero__highlight-icon">{{ ('0' + (i + 1)).slice(-2) }}</span>
            <div>
              <h2>{{ step.label }}</h2>
              <p>{{ step.description }}</p>
            </div>
          </div>
        </div>

        <p class="industry-context__hint" *ngIf="selectedIndustry && currentIndustryContext.hint">
          {{ currentIndustryContext.hint }}
        </p>
      </ng-container>

    </aside>

    <div class="registration-panel">
      <mat-horizontal-stepper [linear]="true" #stepper
                              (selectionChange)="onStepChange($event.selectedIndex)">
        <mat-step [completed]="isAccountStepValid && !emailAlreadyExists">
          <form [formGroup]="userForm" class="registration-card">
            <ng-template matStepLabel>{{ "REGISTER.STEP_COMPANY" | translate }}</ng-template>

            <div class="registration-card__header">
              <p class="registration-card__step">{{ "REGISTER.STEP_LABEL" | translate:{ current: 1, total: 4 } }}</p>
              <h2>{{ "REGISTER.COMPANY_TITLE" | translate }}</h2>
              <p>{{ "REGISTER.COMPANY_SUBTITLE" | translate }}</p>
            </div>

            <div class="registration-card__body">
              <mat-form-field floatLabel="auto" color="accent" class="w-full">
                <mat-label>{{ "REGISTER.COMPANY_NAME" | translate }}</mat-label>
                <input matInput formControlName="organisationDisplayName" />
                <mat-error *ngIf="userForm.controls.organisationDisplayName.touched && userForm.controls.organisationDisplayName.invalid">
                  {{ "REGISTER.REQUIRED_FIELD" | translate }}
                </mat-error>
              </mat-form-field>

              <div class="registration-card__grid">
                <mat-form-field floatLabel="auto" color="accent" class="w-full">
                  <mat-label>{{ "REGISTER.FIRSTNAME" | translate }}</mat-label>
                  <input matInput formControlName="firstname" />
                  <mat-error *ngIf="userForm.controls.firstname.touched && userForm.controls.firstname.invalid">
                    {{ "REGISTER.REQUIRED_FIELD" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field floatLabel="auto" color="accent" class="w-full">
                  <mat-label>{{ "REGISTER.LASTNAME" | translate }}</mat-label>
                  <input matInput formControlName="lastname" />
                  <mat-error *ngIf="userForm.controls.lastname.touched && userForm.controls.lastname.invalid">
                    {{ "REGISTER.REQUIRED_FIELD" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <mat-form-field floatLabel="auto" color="accent" class="w-full">
                <mat-label>{{ "REGISTER.EMAIL" | translate }}</mat-label>
                <input matInput formControlName="email" type="email" />
                <mat-error *ngIf="userForm.controls.email.hasError('required')">
                  {{ "REGISTER.REQUIRED_FIELD" | translate }}
                </mat-error>
                <mat-error *ngIf="userForm.controls.email.hasError('email')">
                  {{ "REGISTER.INVALID_EMAIL" | translate }}
                </mat-error>
                <mat-error *ngIf="userForm.controls.email.hasError('emailExists')">
                  {{ "REGISTER.EMAIL_EXISTS" | translate }}
                </mat-error>
              </mat-form-field>

              <div *ngIf="emailAlreadyExists" class="registration-card__notice">
                <p>{{ "REGISTER.EMAIL_EXISTS_DETAIL" | translate }}</p>
                <div class="registration-card__notice-actions">
                  <a mat-flat-button color="accent" routerLink="/login">
                    {{ "REGISTER.GO_TO_LOGIN" | translate }}
                  </a>
                  <button mat-stroked-button type="button" (click)="useDifferentEmail()">
                    {{ "REGISTER.USE_OTHER_EMAIL" | translate }}
                  </button>
                </div>
              </div>

              <div class="registration-card__grid">
                <mat-form-field floatLabel="auto" color="accent" class="w-full">
                  <mat-label>{{ "REGISTER.PASSWORD" | translate }}</mat-label>
                  <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" />
                  <mat-icon matSuffix (click)="togglePasswordVisibility()" class="cursor-pointer">
                    {{hidePassword ? 'visibility_off' : 'visibility'}}
                  </mat-icon>
                  <mat-error *ngIf="userForm.controls.password.touched && userForm.controls.password.invalid">
                    {{ "REGISTER.INVALID_PASSWORD" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field floatLabel="auto" color="accent" class="w-full">
                  <mat-label>{{ "REGISTER.CONFIRM_PASSWORD" | translate }}</mat-label>
                  <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'" />
                  <mat-icon matSuffix (click)="toggleConfirmPasswordVisibility()" class="cursor-pointer">
                    {{hideConfirmPassword ? 'visibility_off' : 'visibility'}}
                  </mat-icon>
                  <mat-error *ngIf="userForm.controls.confirmPassword.hasError('required')">
                    {{ "REGISTER.REQUIRED_FIELD" | translate }}
                  </mat-error>
                  <mat-error *ngIf="userForm.controls.confirmPassword.hasError('passwordMismatch')">
                    {{ "REGISTER.PASSWORD_MISMATCH" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="password-checklist">
                <p>{{ "REGISTER.PASSWORD_TIP" | translate }}</p>
                <div class="password-checklist__items">
                  <div *ngFor="let check of passwordChecks" class="password-checklist__item" [class.password-checklist__item--valid]="check.valid">
                    <mat-icon>{{ check.valid ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>{{ check.label | translate }}</span>
                  </div>
                </div>
              </div>

              <p class="registration-card__legal-notice">
                {{ "REGISTER.LEGAL_NOTICE_PREFIX" | translate }}
                <a href="https://backoffice.docuty.de/terms" target="_blank" rel="noopener">{{ "REGISTER.TERMS_LINK" | translate }}</a>
                {{ "REGISTER.LEGAL_NOTICE_AND" | translate }}
                <a href="https://backoffice.docuty.de/privacy" target="_blank" rel="noopener">{{ "REGISTER.PRIVACY_LINK" | translate }}</a>{{ "REGISTER.LEGAL_NOTICE_SUFFIX" | translate }}
              </p>
            </div>

            <div class="registration-card__footer">
              <button mat-flat-button color="accent" class="registration-card__primary docuty-cta" type="button" (click)="onAccountStepContinue()">
                {{ "REGISTER.CONTINUE" | translate }}
              </button>
            </div>
          </form>
        </mat-step>

        <mat-step [completed]="isProfileStepValid">
          <div class="registration-card use-case-card">
            <ng-template matStepLabel>{{ "REGISTER.STEP_USE_CASE" | translate }}</ng-template>

            <div class="registration-card__header">
              <p class="registration-card__step">{{ "REGISTER.STEP_LABEL" | translate:{ current: 2, total: 4 } }}</p>
              <h2>{{ "REGISTER.USE_CASE_TITLE" | translate }}</h2>
              <p>{{ "REGISTER.USE_CASE_SUBTITLE" | translate }}</p>
            </div>

            <div class="registration-card__body">

              <!-- 1. Branchenauswahl -->
              <div class="use-case-section">
                <p class="use-case-section__label">{{ "REGISTER.INDUSTRY_LABEL" | translate }}</p>
                <div class="industry-grid">
                  <button *ngFor="let ind of industryCards"
                          type="button"
                          class="industry-chip"
                          [class.industry-chip--selected]="selectedIndustry === ind.id"
                          (click)="selectIndustry(ind.id)">
                    <mat-icon class="industry-chip__icon">{{ ind.icon }}</mat-icon>
                    <span class="industry-chip__label">{{ ind.label }}</span>
                    <mat-icon class="industry-chip__check" *ngIf="selectedIndustry === ind.id">check_circle</mat-icon>
                  </button>
                </div>
              </div>

              <!-- 2. Template-Auswahl (erscheint nach Branchen-Klick) -->
              <div class="use-case-section" *ngIf="selectedIndustry">
                <p class="use-case-section__label">{{ "REGISTER.TEMPLATE_SECTION_LABEL" | translate }}</p>
                <p class="use-case-section__sublabel">{{ "REGISTER.TEMPLATE_SECTION_HINT" | translate }}</p>

                <div class="template-grid">
                  <button *ngFor="let tmpl of sortedTemplates"
                          type="button"
                          class="template-card"
                          [class.template-card--selected]="isTemplateSelected(tmpl.id)"
                          (click)="toggleTemplate(tmpl.id)">
                    <div class="template-card__top">
                      <mat-icon class="template-card__icon">{{ tmpl.icon }}</mat-icon>
                      <span class="template-card__badge" *ngIf="isRecommendedTemplate(tmpl.id)">
                        {{ "REGISTER.TEMPLATE_BADGE_RECOMMENDED" | translate }}
                      </span>
                    </div>
                    <span class="template-card__name">{{ tmpl.name }}</span>
                    <span class="template-card__desc">{{ tmpl.description }}</span>
                    <div class="template-card__check">
                      <mat-icon>{{ isTemplateSelected(tmpl.id) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    </div>
                  </button>
                </div>
              </div>

              <!-- Hinweis Pläne -->
              <div class="registration-card__context">
                <h3>{{ "REGISTER.USE_CASE_HINT_TITLE" | translate }}</h3>
                <p>{{ "REGISTER.USE_CASE_HINT_TEXT" | translate }}</p>
              </div>

            </div>

            <div class="registration-card__footer registration-card__footer--split">
              <button mat-stroked-button class="docuty-secondary" type="button" (click)="goToStep(0)">
                {{ "ACTION.BACK" | translate }}
              </button>
              <button mat-flat-button color="accent" class="registration-card__primary docuty-cta" type="button" (click)="onProfileStepContinue()">
                {{ selectedTemplates.size > 0 ? ("REGISTER.CONTINUE_WITH_TEMPLATES" | translate) : ("REGISTER.CONTINUE" | translate) }}
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <div class="registration-card registration-card--plan" [class.registration-card--plan-full]="stepper.selectedIndex === 2">
            <ng-template matStepLabel>{{ "REGISTER.CHOOSE_PLAN" | translate }}</ng-template>

            <div class="registration-card__body">
              <ui-payment-table
                [preselectedBilling]="preselectedBillingParam"
                [preselectedPlanKey]="preselectedPlanParam"
                (planSelect)="onSubmit($event)">
              </ui-payment-table>
            </div>

            <div class="registration-card__footer">
              <button mat-stroked-button class="docuty-secondary" type="button" (click)="goToStep(1)">
                {{ "ACTION.BACK" | translate }}
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>{{ "REGISTER.PAYMENT" | translate }}</ng-template>
          <div class="registration-card registration-card--loading">
            <mat-spinner diameter="52"></mat-spinner>
            <h2>{{ "REGISTER.PAYMENT_TITLE" | translate }}</h2>
            <p>{{ "REGISTER.PAYMENT_REDIRECT" | translate }}</p>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>

  <footer class="registration-footer">
    <span>v{{ version }}</span>
  </footer>
</section>
